import { Store } from 'lucide-react';

export default function Storefront({ slug }) {
  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center px-6 text-center">
      <div className="p-4 bg-blue-50 rounded-2xl mb-4">
        <Store size={32} className="text-blue-600" />
      </div>
      <h1 className="text-2xl font-bold text-gray-900 capitalize">{slug}'s Shop</h1>
      <p className="text-gray-400 mt-2 text-sm">Storefront coming soon.</p>
    </div>
  );
}
